import { render } from "./SessionCardSkeleton.vue?vue&type=template&id=301dc13b"
const script = {}

import exportComponent from "C:\\Users\\55132870\\Desktop\\GitHub\\leed-summer-conference-23\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QSkeleton});
